export default function MoneyField({
  id,
  name,
  className,
  label,
  value,
  onChange,
  isInvalid,
  error,
  help,
  labelStyle,
  disabled,
  ...props
}) {
  const computedClassName = [
    "form-group",
    "number-field",
    isInvalid ? "has-error" : "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      <label for={id} style={labelStyle} className="control-label">
        {label}
      </label>
      <div className="input-group">
        <span className="input-group-addon">$</span>
        <input
          id={id}
          name={name}
          type="number"
          value={value}
          className="form-control"
          onChange={onChange}
          aria-invalid={isInvalid}
          disabled={disabled}
        />
      </div>
      {isInvalid && !!error && <span className="help-block">{error}</span>}
    </div>
  );
}

MoneyField.defaultProps = {
  className: "",
  onChange: (event) => {},
  value: "",
};
